(() => {
  if (customElements.get('product-message')) return;

  class ProductMessage extends HTMLElement {
    connectedCallback() {
      this.blockId = this.dataset.blockId || this.id || 'default';
      this.storageKey = `product-message-closed-${this.blockId}`;
      this.closeButton = this.querySelector('.js-close-message');
      this.isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

      this.evaluateVisibility();

      if (this.closeButton && this.dataset.closeListenerAdded !== 'true') {
        this.dataset.closeListenerAdded = 'true';

        this.closeButton.addEventListener('click', () => {
          this.closeMessage(true);
        });
      }

      if (!this.isDesignMode && this.dataset.autoHide === 'true' && this.dataset.autoHideStarted !== 'true') {
        this.dataset.autoHideStarted = 'true';

        const seconds = parseInt(this.dataset.visibilityDuration || '7', 10);

        if (seconds > 0) {
          window.setTimeout(() => {
            this.closeMessage(false);
          }, seconds * 1000);
        }
      }
    }

    evaluateVisibility() {
      if (!this.shouldDisplay()) {
        this.hidden = true;
        return;
      }

      this.hidden = false;
    }

    shouldDisplay() {
      if (!this.isDesignMode && this.dataset.persistentClose === 'true') {
        try {
          if (window.localStorage.getItem(this.storageKey) === 'true') {
            return false;
          }
        } catch (error) {
          // Storage may be blocked. Continue without persistent close.
        }
      }

      const startsAt = this.parseDate(this.dataset.triggerActivate);
      const endsAt = this.parseDate(this.dataset.triggerDeactivate);
      const now = new Date();

      if (startsAt && now < startsAt) {
        return false;
      }

      if (endsAt && now > endsAt) {
        return false;
      }

      if (this.isDesignMode) {
        return true;
      }

      return this.discountCodeMatches();
    }

    parseDate(value) {
      if (!value) return null;

      const trimmed = String(value).trim();

      if (!trimmed) return null;

      const normalized = trimmed.replace(' ', 'T');
      const parsed = new Date(normalized);

      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    discountCodeMatches() {
      const requiredCode = (this.dataset.triggerDiscountCode || '').trim().toLowerCase();

      if (!requiredCode) {
        return true;
      }

      const valuesToSearch = [
        document.cookie || '',
        window.location.search || '',
        window.location.pathname || ''
      ];

      try {
        valuesToSearch.push(window.localStorage.getItem('discount_code') || '');
        valuesToSearch.push(window.localStorage.getItem('discountCode') || '');
        valuesToSearch.push(window.sessionStorage.getItem('discount_code') || '');
        valuesToSearch.push(window.sessionStorage.getItem('discountCode') || '');
      } catch (error) {
        // Storage may be unavailable. Cookie, URL, and pathname checks still run.
      }

      return valuesToSearch.some((value) => {
        try {
          return decodeURIComponent(value).toLowerCase().includes(requiredCode);
        } catch (error) {
          return String(value).toLowerCase().includes(requiredCode);
        }
      });
    }

    closeMessage(saveClose = true) {
      if (!this.isDesignMode && saveClose && this.dataset.persistentClose === 'true') {
        try {
          window.localStorage.setItem(this.storageKey, 'true');
        } catch (error) {
          // Ignore storage failures. The message can still close for this page view.
        }
      }

      this.classList.add('is-closing');

      window.setTimeout(() => {
        this.hidden = true;
        this.classList.remove('is-closing');
      }, 180);
    }
  }

  customElements.define('product-message', ProductMessage);
})();